import { render, staticRenderFns } from "./LoginFooter.vue?vue&type=template&id=b556e1ac&scoped=true&"
import script from "./LoginFooter.vue?vue&type=script&lang=js&"
export * from "./LoginFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b556e1ac",
  null
  
)

export default component.exports